export const content = [
  `Welcome! Nestly is a time tracker that lets you nest tasks as many times as you want.<br/><br/>
    You can type here to add an item.<br/>
    Tag items using hashtags.`,
  `You can focus an item by clicking on its text. Press <kbd>ENTER</kbd> to add a new item.<br/>`,
  `See your tags and filter the items by clicking a tag in the sidebar.`,
  `Use these buttons to indent and dedent items.<br/>
    You can also use <kbd>TAB</kbd> and <kbd>SHIFT</kbd>+<kbd>TAB</kbd>.`,
  `Or just drag and drop items (using the time tracked handles) where you want them!`,
  `Start tracking time for an item by clicking here.`,
  `Made a mistake?<br/>
    Edit tracked time using this dialog.`,
  `Made a big mistake?<br/>
    Delete an entire item here.`,
  `Stop tracking time by clicking this button.`,
  `View graphs for recently tracked time here.`,
  `If you have subtasks, weekly breakdowns are shown by subtask and by tags.<br/><br/>
    You can hover or tap bars to see more details.`,
    `Thats it!<br/><br/>
    We hope you find Nestly useful.`
];

export const targets = [
  "#task-content",
  "#app > div.flex.mb5 > div.w-100 > div:nth-child(2) > div:nth-child(2)",
  "#sidebar", 
  "#dent",
  "#task-content > p",
  "#play-btn",
  "#edit-btn",
  "#delete-btn",
  "#app > div.flex.mb5 > div.w-100 > div:nth-child(1) > div > button",
  "#stats-btn",
  "html",
  "html"
]

let focus = type => new Promise(resolve => {
  type;
  document.querySelector("#task-content > div > p").click();
  resolve();
});

export const scripts = [
  null,
  null,
  focus,
  focus,
  null,
  focus,
  type => new Promise(resolve => {
    type;
    document.querySelector("#play-btn").click();
    document.querySelector("#task-content > div > p").click();
    resolve();
  }),
  focus,
  null,
  type => new Promise(resolve => {
    type;
    document.querySelector("#app > div.flex.mb5 > div.w-100 > div:nth-child(1) > div > button").click();
    document.querySelector("#task-content > div > p").click();
    resolve();
  }),
  type => new Promise(resolve => {
    type;
    document.querySelector("#task-content > div > p").click();
    document.querySelector("#stats-btn").click();
    resolve();
  }),
  type => new Promise(resolve => {
    type;
    window.history.back();
    resolve();
  })
];
